import React, {createRef, useState, useContext} from 'react';
import { Form,  Alert } from '../../../controls';
import SystemContext from "../../../SystemContext";
import ShipmentTrackingActivityGrid from "./ShipmentTrackingActivityGrid";
import FlightsMapContainer from "./FlightsMapContainer";

const ShipmentTrackingForm = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const classes = props.classes;

  const [record, setRecord] = useState(props.record);
  const [editing, setEditing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: ""
  });

  if ((props.record && !record) || (!props.record && record) || (props.record && record && props.record.awbNo !== record.awbNo) ) {
    setRecord(props.record);
    setEditing(false);
  }

  const SystemData = useContext(SystemContext);

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}}>
      <Alert
        key="alert"
        onChange={(open) => {
          setAlert({ ...alert, open })
        }}
        open={alert.open}
        severity={alert.severity}
        message={alert.message}
        timeOut={alert.timeOut || 0}
      />
      {record ?
      <div>
        <Form key="form"
//          title={(record)=>{return `Shipment Activity for ${record.awbNo}`}}
          message=""
          open={true}
          record={record}
          style={{backgroundColor: "rgb(238, 238, 238)"}}
          formBodyStyle={{maxHeight: (props.canEdit ? "calc(100vh - 320px)" : "calc(100vh - 120px)"), backgroundColor: "none", paddingLeft:0, paddingRight:20}}
          buttonBarStyle={{width: (props.canEdit ? "calc(100% - 20px)" : "0px")}}
          buttons = {editing?
            {
              save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}}, 
              cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
            }: props.canEdit?{
              edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"}
            }: {}
          }

          onChange={(state) => {
            if (state.buttonPressed === "edit" && props.canEdit) {
              setEditing(true);
            }
            if (state.buttonPressed === "cancel") {
              setEditing(false);
              setRecord(props.record);
            }
            if (state.buttonPressed === "save") {
              SystemData.toggleLoadingProgress(true);
              const record = state.record;
              // handleUpdateCountryPermitRequirement.mutate({
              //   extraKeys,
              //   record,
              //   postSuccess: () => {
              //     setEditing(false);
              //     SystemData.toggleLoadingProgress(false);
              //     setAlert({ severity: "info", open: true, message: "Record Updated", timeOut: 5 });
              //   },
              //   postError: (data) => {
              //     SystemData.toggleLoadingProgress(false);
              //     if (data.errorMessage) {
              //       SystemData.alert("Error", `${data.errorMessage}`);
              //     } else {
              //       SystemData.alert("Error", `An Unexpected Error has occurred creating the trip.`);
              //     }
              //   }
              // });
            } else {
            }
          }}
        >
          <ShipmentTrackingActivityGrid
            awb={"232-11111111"} //TODO: bind this record.awb_no
          />
        </Form>
      </div>
      :<></>
    }
    </div>
  );
}

export default ShipmentTrackingForm;
